import { createSlice } from "@reduxjs/toolkit";

const moviesSlices= createSlice({
    name:"movies",
    initialState:{
        nowPlayingMovies:null,
        trailerVideo:null,
        popularMovies:null,
        topRatedMovies:null,
        upComingMovies:null,
    },
    reducers:{
        addNowPlayingMovies: (state,action)=>{
            state.nowPlayingMovies = action.payload;
        },
        addTrailerVideo:(state,action)=>{
            state.trailerVideo= action.payload;
        },
        addPopularMovies:(state,action)=>{
            state.popularMovies= action.payload;
        },
        addTopRatedMovies:(state,action)=>{
            state.topRatedMovies= action.payload;
        },
        addUpComingMovies:(state,action)=>{
            state.upComingMovies= action.payload;
        },
        removeResource:(state,action)=>{
            return null;
        }
    }
})
export default moviesSlices.reducer;
export const {addNowPlayingMovies, addTrailerVideo, removeResource, addPopularMovies, addTopRatedMovies,addUpComingMovies}= moviesSlices.actions;